<template>
  <thead :class="theadClasses">
    <tr>
      <th
        v-for="header in headers"
        :key="header.value"
        :class="headerClasses(header)"
        @click="handleClick(header)"
        class="textAlignment"
      >
        {{ header.text }}
      </th>
      <slot></slot>
    </tr>
  </thead>
</template>

<script>
export default {
  props: {
    headers: Array,
    color: {
      type: String,
      default: "secondaryLight",
      // default: "py-4 light secondaryLight--text",
    },
    fontColor: {
      type: String,
      default: "white--text",
    },
  },
  data: () => ({
    theadAtt: {},
    thAtt: {},
  }),
  computed: {
    theadClasses() {
      return {
        [this.color]: !this.isHex(this.color),
        [this.fontColor]: !this.isHex(this.color),
      };
    },
    theadStyle() {
      return {
        backgroundColor: this.isHex(this.color) && this.color,
        fontColor: this.isHex(this.fontColor) && this.fontColor,
      };
    },
    thClasses() {
      // return { }
    },
  },
  methods: {
    setColor() {
      let object;
      if (this.isHex(this.color)) {
        object = { style: { backgroundColor: this.color } };
      } else {
        object = { class: this.color };
      }
      this.theadAtt = object;
    },
    isHex(text = "") {
      return text.includes("#");
    },
    handleClick(headerItem) {
      this.$emit("header-click", headerItem);
    },
    headerClasses(headerItem) {
      const classes = [this.executeClassMethods(headerItem), 'pl-3 pr-3'];
      return classes;
    },
    executeClassMethods(headerItem) {
      const methods = [this.alignment, this.sortable];
      const results = new Set();
      methods.forEach((method) => {
        const d = method({ ...headerItem });
        results.add(d);
      });
      return [...results];
    },
    alignment(headerItem = {}) {
      const align = headerItem.align || "";
      switch (align) {
        case "left":
          return "align-left";
        case "right":
          return "align-right";
        default:
          return "align-center";
      }
    },
    sortable(headerItem = {}) {
      return headerItem.sortable === true || headerItem.sortable === "true"
        ? "clickable"
        : "";
    },
  },
};
</script>

<style scoped>
tr {
  height: 50px;
}
.align-center {
  text-align: center;
}
.align-left {
  text-align: left;
}
.align-right {
  text-align: right;
}
.clickable {
  cursor: pointer;
}
th:first-child {
  border-radius: 8px 0 0 8px;
}
th:last-child {
  border-radius: 0 8px 8px 0;
}

.textAlignment{
  text-align: left !important;
}
</style>